import React from "react";
import Modal from "../../../shared/components/Modal/Modal";
import weeklyActivityInfoIcon from "../../../utilities/images/study_dashboard/weekly_activity_info_modal_icon.svg";
import "./WeeklyActivityInfoModal.css";

const INFO_ITEMS = [
  {
    id: "questions",
    title: "Questions",
    description:
      "This represents all practice and test questions you attempted this week.",
  },
  {
    id: "accuracy",
    title: "Accuracy",
    description:
      "Your proficiency rate, calculated as (Correct/Total Attempts) x 100.",
  },
  {
    id: "xp",
    title: "XP Points",
    description:
      "Total XP Points earned this week, awarding 10 points for every correct answer and 5 points for every incorrect attempt.",
  },
];

const WeeklyActivityInfoModal = ({ isOpen, onClose }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    closeAboveModal
    stackClassName="weekly-activity-info-modal__dialog-stack"
    width="100%"
    height="auto"
    maxWidth="400px"
    borderRadius="12px"
    marginTop="0"
    padding="10px 18px 18px"
    display="flex"
    flexDirection="column"
    alignItems="stretch"
    justifyContent="flex-start"
    textAlign="center"
    closeButtonStyle={{
      width: "36px",
      height: "36px",
      padding: "0",
      fontSize: "12px",
      background: "#0f172a",
      boxShadow: "4px 4px 4px rgba(63, 63, 63, 0.16)",
    }}
  >
    <div className="weekly-activity-info-modal">
      <img
        src={weeklyActivityInfoIcon}
        alt=""
        className="weekly-activity-info-modal__icon"
        aria-hidden="true"
      />

      <div className="weekly-activity-info-modal__content">
        <h3 className="weekly-activity-info-modal__title">
          Weekly Activity Breakdown
        </h3>

        <div className="weekly-activity-info-modal__cards">
          {INFO_ITEMS.map((item) => (
            <article key={item.id} className="weekly-activity-info-modal__card">
              <p className="weekly-activity-info-modal__card-title">{item.title}</p>
              <p className="weekly-activity-info-modal__card-description">
                {item.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </div>
  </Modal>
);

export default WeeklyActivityInfoModal;
